import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { getAxiosInterceptor, getHeader } from '../util/axios_helper'
import {
  sandboxTestingBaseUrl,
  serviceNameRouteMapping,
  versions,
} from '../config/services'

import config from '../config'
import servicesConfig from '../config/services'

export enum ResponseBodyTypeEnum {
  SEND_COMPLETE_RESPONSE,
  SEND_RESPONSE_DATA,
}

export default class BaseService {
  protected baseUrl: string
  protected axiosInstance: AxiosInstance
  protected secondaryInstance: AxiosInstance
  protected noJWTInstance: AxiosInstance
  protected headers
  protected config = config
  static servicesConfig = servicesConfig
  protected responseBodyTypeEnum = ResponseBodyTypeEnum
  protected responseBodyType: ResponseBodyTypeEnum =
    ResponseBodyTypeEnum.SEND_RESPONSE_DATA
  protected useNewToken: boolean

  constructor(baseUrl: string, useNewToken: boolean = false, skipInterceptor: boolean = false) {
    const serviceName = this.constructor?.name // this gets the name of the child class

    this.useNewToken = useNewToken
    this.headers = getHeader()

    if (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_DEVELOPER_VERSION !== 'default') {
      this.headers.developer_version = process.env.VUE_APP_DEVELOPER_VERSION

    }

    this.baseUrl = baseUrl
    this.axiosInstance = axios.create({
      baseURL: baseUrl,
    })

    this.secondaryInstance = axios.create({
      baseURL: baseUrl,
    })

    this.noJWTInstance = axios.create({
      baseURL: baseUrl,
      headers: getHeader()
    })

    this.axiosInstance.interceptors.request.use(
      getAxiosInterceptor(this.headers, useNewToken, skipInterceptor)
    )
  }

  protected responseBody = (res: AxiosResponse) => {
    if (
      this.responseBodyType === this.responseBodyTypeEnum.SEND_COMPLETE_RESPONSE
    ) {
      return res
    }
    return res.data
  }

  protected requests = {
    get: async (url: string, options = {}) => {
      return this.axiosInstance({
        url: this.baseUrl + url,
        method: 'GET',
        ...options,
      }).then(this.responseBody)
    },
    post: async (url: string, body: { [key: string]: any }, options = {}) =>
      this.axiosInstance({
        url: this.baseUrl + url,
        method: 'POST',
        data: body,
        ...options,
      }).then(this.responseBody),
    put: async (url: string, body: { [key: string]: any }) =>
      this.axiosInstance({
        url: this.baseUrl + url,
        method: 'PUT',
        data: body,
      }).then(this.responseBody),
    delete: async (
      url: string,
      options = {},
      body: { [key: string]: any } = {}
    ) =>
      this.axiosInstance({
        url: this.baseUrl + url,
        data: body,
        method: 'DELETE',
        ...options,
      }).then(this.responseBody),
  }
}